import { required, maxLength, minValue, integer } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    description: { required, maxLength: maxLength(30) },
    strategy: { required },
    time: { required, integer, minValue: minValue(5), maxLength: maxLength(2) },
  },
}

export const validateComputed = {
  descriptionErrors() {
    const errors = []
    if (!this.$v.form.description.$dirty) return errors
    !this.$v.form.description.required && errors.push('Descrição é obrigatória.')
    !this.$v.form.description.maxLength && errors.push('Descrição não pode conter mais de 30 caracteres.')
    return errors
  },
  strategyErrors() {
    const errors = []
    if (!this.$v.form.strategy.$dirty) return errors
    !this.$v.form.strategy.required && errors.push('Estratégia é obrigatória.')
    return errors
  },
  timeErrors() {
    const errors = []
    if (!this.$v.form.time.$dirty) return errors
    !this.$v.form.time.required && errors.push('Tempo é obrigatório.')
    !this.$v.form.time.integer && errors.push('Inserir apenas valores numéricos.')
    !this.$v.form.time.minValue && errors.push('Menor valor aceito: 5.')
    !this.$v.form.time.maxLength && errors.push('São permitidos no máximo 2 dígitos.')
    return errors
  },
}
